var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_689)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_53_689)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_53_689)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.961 3.22401C19.9448 3.15016 19.9094 3.0819 19.8583 3.02614C19.8072 2.97039 19.7423 2.92912 19.6702 2.90651C19.4074 2.85447 19.1355 2.87374 18.8827 2.96234C18.8827 2.96234 1.35851 9.2615 0.357677 9.959C0.142677 10.109 0.0701766 10.1965 0.0343433 10.299C-0.13899 10.799 0.400177 11.014 0.400177 11.014L4.91684 12.4857C4.99321 12.4993 5.07174 12.4948 5.14601 12.4723C6.17267 11.8232 15.4793 5.94401 16.0202 5.74651C16.1035 5.72151 16.1677 5.74651 16.151 5.80901C15.936 6.56318 7.89351 13.7073 7.84934 13.7507C7.82783 13.7683 7.81107 13.791 7.80058 13.8168C7.79011 13.8425 7.78624 13.8705 7.78934 13.8982L7.36768 18.3082C7.36768 18.3082 7.19101 19.6807 8.5635 18.3082C9.53683 17.334 10.471 16.5273 10.9377 16.1348C12.491 17.2073 14.1618 18.3932 14.8827 19.014C15.0039 19.1313 15.1476 19.2231 15.3051 19.2837C15.4626 19.3442 15.6307 19.3724 15.7993 19.3665C16.007 19.3412 16.2021 19.2533 16.3585 19.1143C16.515 18.9754 16.6254 18.7922 16.6752 18.589C16.6752 18.589 19.8668 5.73651 19.9735 4.01484C19.9843 3.84818 19.9985 3.73818 20.0002 3.62234C20.0054 3.4884 19.9922 3.35438 19.961 3.22401Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.83,
    fill: "white",
    transform: "translate(0 0.584961)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_53_689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.83,
    fill: "white",
    transform: "translate(0 0.584961)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_53_689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.8333,
    fill: "white",
    transform: "translate(0 0.583496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.7985f16284ba840221321e1a0b4e3925.svg";
export { ForwardRef as ReactComponent };